// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_FFD","cls2":"SuggestionCard-cls2__33 SuggestionCard-cls1_FFD"};